import React from 'react';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import Grid from '@mui/material/Grid';
import Typography from '@mui/material/Typography';

import DeleteForeverIcon from '@mui/icons-material/DeleteForever';
import UndoIcon from '@mui/icons-material/Undo';

import {
    CautionButton,
    GrayButton
} from '../css/CSS.js';


export default function UnconfirmedCheckDialog(props) {
    const handleClose = () => {
        props.cancelClick();
    };

    const handleOpen = () => {
        props.exeClick();
    }

    return (
        <Dialog
            open={props.open}
            onClose={handleClose}
            aria-labelledby="alert-dialog-title"
            aria-describedby="alert-dialog-description"
        >
            <DialogTitle id="alert-dialog-title"
                sx={{
                    fontSize: '2rem',
                    color: '#ffffff',
                    py: 3,
                    backgroundColor: "#1976d2",
                    justifyContent: "center",
                    alignItems: "center",
                }}>
                {"変更内容が確定されていません"}
            </DialogTitle>
            <DialogContent>
                <Typography sx={{ fontSize: '1.5rem', p: 3 }}>
                    変更内容を破棄してよろしいですか？
                </Typography>
            </DialogContent>
            <DialogActions>
                <Grid container
                    sx={{
                        justifyContent: "space-between",
                        alignItems: "center",
                        mb: 2
                    }}>
                    <GrayButton variant="contained" size="large" onClick={handleClose}
                        sx={{ ml: 2, mr: 2, pt: 1, pb: 1, pl: 2, pr: 3, fontSize: '1.2rem' }} >
                        <UndoIcon sx={{ mr: 2, fontSize: '2rem' }} />
                        いいえ
                    </GrayButton>
                    <CautionButton variant="contained" size="large" onClick={handleOpen}
                        sx={{ ml: 2, mr: 2, pt: 1, pb: 1, pl: 2, pr: 3, fontSize: '1.2rem' }} >
                        <DeleteForeverIcon sx={{ mr: 2, fontSize: '2rem' }} />
                        はい
                    </CautionButton>
                </Grid>
            </DialogActions>
        </Dialog>)
}